import AuthenticationServices from "@/http/api/auth/AuthenticationServices";
import {useMutation, useQuery} from "@tanstack/react-query";
import Cookies from "js-cookie";

export default class AuthenticationQueryHooks extends AuthenticationServices{
    getToken = ()  => {
        return Cookies.get("token") ? Cookies.get("token") : null;
    }

    useRequest = () => {
        return useMutation({
            mutationKey : ["request"],
            mutationFn :  (contact : string) =>  this.request(contact)
        })
    }

    useVerify = () => {
        return useMutation({
            mutationKey : ["request-verify-otp"],
            mutationFn :  (data : {
                otp: string ,
                contact: string
            }) => this.verify(data?.otp , data?.contact)
        })
    }

    useLogin = () => {
        return useMutation({
            mutationKey : ["login"],
            mutationFn :  (data : {
                contact : string ,
                password : string
            }) => this.login(data?.password , data.contact)
        })
    }

    useIsVerify = () => {
        return useQuery({
            queryKey : ["isVerify"],
            queryFn : () => this.isVerify(this.getToken()),
            select : (data : any) => data?.data
        })
    }
    useIsUserVerify = () => {
        return useMutation({
            mutationKey : ["isVerify"],
            mutationFn : (token : string) => this.isVerify(token),
        })
    }
}